/* eslint-disable prettier/prettier */

const { hostname } = window.location

export const host = process.env.REACT_APP_PROD_URL // Production url

// export const host = /dev|local/.test(hostname)
//   ? process.env.REACT_APP_DEV_URL // in case its the local environment connect to development
//   : /stage/.test(hostname)
//   ? process.env.REACT_APP_STAGE_URL
//   : process.env.REACT_APP_QA_URL // Production url

const baseUrl = `https://${host}`

// const customerId = process.env.REACT_APP_STAGE_CUSTOMER_ID
// export const smallHolderApi = () => `${baseUrl}/v1/openApis/small-holder/${customerId}`

export const ssoLoginUrl = () => `${baseUrl}/v1/user/ssoLogin`
export const ssoResponseUrl = () => `${baseUrl}/v1/user/ssoResponse`
export const ssoLogoutUrl = () => `${baseUrl}/v1/user/ssoLogout`

// Configurations apis
export const createOrUpdateBannerConfigUrl = () => `${baseUrl}/api/v1/banner/banner-config`
export const fetchBannerConfigUrl = (countryId) => `${baseUrl}/api/v1/banner/banner-config`
export const fetchCountryConfigUrl = () => `${baseUrl}/api/v1/configuration?type=Country`
export const fetchLoyaltyMasterConfigUrl = (type) => `${baseUrl}/api/v1/configuration?type=${type}`
export const fetchLoyaltyConfigValuesUrl = (type) =>
  `${baseUrl}/api/v1/configuration/values?type=${type}`
export const editLoyaltyConfigValuesUrl = () => `${baseUrl}/api/v1/configuration/values`
export const fetchCountryFeaturesUrl = () => `${baseUrl}/api/v1/country/features`

// country section apis
export const uploadAppLogo = () => `${baseUrl}/api/v1/country/uploadAppLogo`
export const fetchAllCountries = () => `${baseUrl}/api/v1/country`
export const addCountries = () => `${baseUrl}/api/v1/country`

// Banner management apis
export const fetchBannersUrl = ({
  bannerId,
  stateId,
  countryId,
  businessUnit = 'CP',
  limit = 1000,
}) =>
  `${baseUrl}/api/v1/banner?businessUnit=${businessUnit}${
    stateId ? `&stateId=${stateId}` : ''
  }&limit=${limit}`
export const addBannerUrl = () => `${baseUrl}/api/v1/banner`
export const editBannerUrl = () => `${baseUrl}/api/v1/banner`
export const deleteBannerUrl = (id) => `${baseUrl}/api/v1/banner/${id}`
export const uploadBannerImageUrl = () => `${baseUrl}/api/v1/banner/uploadBannerImage`

// point adjustment apis
export const fetchTransactions2 = ({
  limit,
  page,
  mobileNumber,
  supportAction,
  serialNumber,
  displayId,
}) =>
  `${baseUrl}/api/v1/adjustment/scan-history?limit=${limit}&page=${page}&mobileNumber=${mobileNumber}&serialNumber=${serialNumber}&displayId=${displayId}&priorityCheck=${supportAction}`

export const fetchTransactions = ({
  limit,
  page,
  mobileNumber = '',
  priorityCheck = '',
  serialNumber = '',
  displayId = '',
  productIds = '',
  stateId = '',
  eligibleForCashback,
}) => {
  let url = `${baseUrl}/api/v1/adjustment/scan-history?limit=${limit}&page=${page}`

  if (mobileNumber) {
    url += `&mobileNumber=${mobileNumber}`
  }

  if (serialNumber) {
    url += `&serialNumber=${serialNumber}`
  }

  if (displayId) {
    url += `&displayId=${displayId}`
  }

  if (priorityCheck) {
    url += `&priorityCheck=${priorityCheck}`
  }

  if (eligibleForCashback !== undefined) {
    url += `&eligibleForCashback=${eligibleForCashback}`
  }

  if (productIds) {
    url += `&productIds=${productIds}`
  }

  if (stateId) {
    url += `&stateId=${stateId}`
  }

  return url
}

export const fetchTransactionsByDateRange = () => `${baseUrl}/api/v1/adjustment/scan-history`
export const pointsAdjustment = () => `${baseUrl}/api/v1/adjustment`
export const bulkActions = () => `${baseUrl}/api/v1/adjustment/bulkActions`
export const adjustLastValidScanUrl = (days) =>
  `${baseUrl}/api/v1/scanAndEarn/lastValidScan?lastXdays=${days}`

// redemption apis
export const fetchRedemptions = (query) => `${baseUrl}/api/v1/redeem/portal/history${query}`

// product based rule apis
export const fetchProductBasedRulesUrl = (
  skip = 0,
  limit = 1000,
  productName = '',
  sortBy = 'productName',
  orderBy = 'asc',
) =>
  `${baseUrl}/api/v1/ruleEngine?skip=${skip}&limit=${limit}&productName=${productName}&sortBy=${sortBy}&orderBy=${orderBy}`
export const addProductBasedRuleUrl = () => `${baseUrl}/api/v1/ruleEngine`
export const editProductBasedRuleUrl = (id) => `${baseUrl}/api/v1/ruleEngine/${id}`
export const deleteProductBasedRuleUrl = (id) => `${baseUrl}/api/v1/ruleEngine/${id}`
export const addCashbackRuleUrl = () => `${baseUrl}/api/v1/ruleEngine/cashbackRule`
export const editCashbackRuleUrl = (id) => `${baseUrl}/api/v1/ruleEngine/cashbackRule/${id}`
export const deleteCashbackRuleUrl = (id) => `${baseUrl}/api/v1/ruleEngine/cashbackRule/${id}`
export const fetchCashbackRulesUrl = (
  skip = 0,
  limit = 1000,
  sortBy = 'productName',
  orderBy = 'asc',
) =>
  `${baseUrl}/api/v1/ruleEngine/cashbackRule?skip=${skip}&limit=${limit}&sortBy=${sortBy}&orderBy=${orderBy}`

// fetch geoLocation master data -> states, districts, provinces & divisions
export const fetchStatesGeolocationMasterDataUrl = (page = 0, limit = 10) =>
  `${baseUrl}/api/v1/state/portal?page=${page}&limit=${limit}`
export const fetchDistrictsGeolocationMasterDataUrl = (page = 0, limit = 10) =>
  `${baseUrl}/api/v1/district/portal?page=${page}&limit=${limit}`
export const fetchProvincesGeolocationMasterDataUrl = (page = 1, limit = 10) =>
  `${baseUrl}/api/v1/province/portal?page=${page}&limit=${limit}`
export const fetchDivisionsGeolocationMasterDataUrl = (page = 1, limit = 10) =>
  `${baseUrl}/api/v1/division/portal?page=${page}&limit=${limit}`

// create geoLocation Master Data
export const createStateGeoLocationMasterDataUrl = () => `${baseUrl}/api/v1/state/portal`
export const createDistrictGeoLocationMasterDataUrl = () => `${baseUrl}/api/v1/district/portal`
export const createProvinceGeoLocationMasterDataUrl = () => `${baseUrl}/api/v1/province/portal`
export const createDivisionGeoLocationMasterDataUrl = () => `${baseUrl}/api/v1/division/portal`

// update geoLocation Master Data
export const updateStateGeoLocationMasterDataUrl = (id) => `${baseUrl}/api/v1/state/portal/${id}`
export const updateDistrictGeoLocationMasterDataUrl = (id) =>
  `${baseUrl}/api/v1/district/portal/${id}`
export const updateProvinceGeoLocationMasterDataUrl = (id) =>
  `${baseUrl}/api/v1/province/portal/${id}`
export const updateDivisionGeoLocationMasterDataUrl = (id) =>
  `${baseUrl}/api/v1/division/portal/${id}`

// fetch products, brands and states
export const fetchProductsUrl = () => `${baseUrl}/api/v1/product/productList`
export const fetchBrandsUrl = () => `${baseUrl}/api/v1/product/portal/brands`

//fetch region types
export const fetchStatesUrl = () => `${baseUrl}/api/v1/state`
export const fetchDistrictsUrl = () => `${baseUrl}/api/v1/district`
export const fetchDivisionsUrl = () => `${baseUrl}/api/v1/division`
export const fetchProvincesUrl = () => `${baseUrl}/api/v1/province`

// products master data apis
export const fetchProductMasterDataUrl = (
  skip = 0,
  limit = 1000,
  productName = '',
  brandName = '',
  sortBy = 'productName',
  orderBy = 'asc',
) =>
  `${baseUrl}/api/v1/product/portal?skip=${skip}&limit=${limit}&productName=${productName}&brandName=${brandName}&sortBy=${sortBy}&orderBy=${orderBy}`
export const addProductMasterDataUrl = () => `${baseUrl}/api/v1/product`
export const editProductMasterDataUrl = (id) => `${baseUrl}/api/v1/product/${id}`
export const deleteProductMasterDataUrl = (id) => `${baseUrl}/api/v1/product/${id}`

// Tier master data apis
export const fetchTierMasterDataUrl = (
  skip = 0,
  limit = 1000,
  tierName = '',
  sortBy = 'tierName',
  orderBy = 'asc',
) =>
  `${baseUrl}/api/v1/tier/portal?skip=${skip}&limit=${limit}&tierName=${tierName}&sortBy=${sortBy}&orderBy=${orderBy}`
export const addTierMasterDataUrl = () => `${baseUrl}/api/v1/tier`
export const editTierMasterDataUrl = (id) => `${baseUrl}/api/v1/tier/${id}`
export const deleteTierMasterDataUrl = (id) => `${baseUrl}/api/v1/tier/${id}`
export const uploadTierImageUrl = () => `${baseUrl}/api/v1/tier/uploadTierPicture`

// api details api
export const fetchApiDetailsUrl = () => `${baseUrl}/api/v1/analytics/portal/api-logs`

// Portal User management apis
export const fetchPortalUsersUrl = (
  skip = 0,
  limit = 500,
  name = '',
  sortBy = 'tierName',
  orderBy = 'asc',
) => `${baseUrl}/v1/user/portal/management/list?skip=${skip}&limit=${limit}&name=${name}`
export const addPortalUserUrl = () => `${baseUrl}/v1/user/portal/create`
export const editPortalUserUrl = () => `${baseUrl}/v1/user`

// member list apis
export const fetchMemberListUrl = (
  skip = 0,
  limit = 500,
  mobileNumber = '',
  sortBy = 'tierName',
  orderBy = 'asc',
) => `${baseUrl}/v1/user/portal/member/list?skip=${skip}&limit=${limit}`
export const fetchMemberUpdatedHistoryUrl = () => `${baseUrl}/v1/user/portal/member/history`
export const fetchMemberListNotificationUrl = (
  skip = 0,
  limit = 500,
  startTimestamp = '',
  endTimestamp = '',
  sortBy = 'tierName',
  orderBy = 'asc',
) =>
  `${baseUrl}/v1/user/portal/notification?skip=${skip}&limit=${limit}&startTimestamp=${startTimestamp}&endTimestamp=${endTimestamp}`
export const editMemberListUrl = () => `${baseUrl}/v1/user`

//Roles And Access
export const createRoleUrl = () => `${baseUrl}/api/v1/role`
export const fetchRolesUrl = () => `${baseUrl}/api/v1/role/list`
export const editRolesUrl = (id) => `${baseUrl}/api/v1/role/${id}`
export const fetchFeaturesUrl = (limit = 500) => `${baseUrl}/api/v1/permission/list?limit=${limit}`

// Campaign API's
export const fetchCampaigns = (query) => `${baseUrl}/external/v1/portal/campaigns${query}`
export const fetchCampaignUserDataUrl = (query) =>
  `${baseUrl}/external/v1/portal/campaign-user-data${query}`
export const fetchCampaignUserCouponsUrl = (query) =>
  `${baseUrl}/external/v1/portal/campaign-user-coupons${query}`
export const fetchCampaignMetaDataUrl = (query) =>
  `${baseUrl}/external/v1/portal/campaign-meta-data${query}`
export const createCampaignUrl = () => `${baseUrl}/external/v1/portal/add-campaign`
export const updateCampaignUrl = () => `${baseUrl}/external/v1/portal/update-campaign`
export const fetchCampaignRuleUrl = () => `${baseUrl}/external/v1/portal/campaignrules`
export const addUpdateCampaignRuleUrl = () => `${baseUrl}/external/v1/portal/campaign-rule`
export const campaignSettingUrl = () => `${baseUrl}/api/v1/campaigns/campaign-config`
// Export API's
export const fetchExportListUrl = () => `${baseUrl}/api/v1/exports/portal`

export const uploadFileUrl = () => `${baseUrl}/external/v1/portal/uploadWinners`

export const uploadInvoiceUrl = () => `${baseUrl}/api/v1/campaigns/upload-luckydraw-invoice`

export const fetchWinnersListUrl = () => `${baseUrl}/api/v1/campaigns/portal/winners-list`
